/* eslint-disable react/jsx-no-target-blank */
import React, { Component, Fragment } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Popover } from 'antd';
import { observer } from 'mobx-react';
import InfoRow from '../../common/InfoRow';
import { text2 } from '../../../constants/classes';
import ProfitFormula from './ProfitFormula';
import { arrowUp, arrowDown } from '../../../constants/classes/arrow';
import { CollapseButton, SubTitle } from '../../common/SingleItem';
import { formatOfferUrl, formatOrderUrl } from '../../../utils/formatMarketsUrl';
import IconSvg from '../../common/IconSvg';
import { InfoValue } from '../../common/styled';

const getFormattedDate = date => (date ? moment(date).format('YYYY-MM-DD') : '');

@injectIntl
@observer
export default class ItemInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
      STUEditMode: false,
      hasImage:false
    };
    this.toggleShowMore = this.toggleShowMore.bind(this);
  }

  componentDidMount(){
    const {
      data
    } = this.props;
    this.isImage(`https://tracking-html.s3.us-east-2.amazonaws.com/tracking-images/${data.sourceOrderNumber}`)
  }

  toggleShowMore() {
    this.setState(({ showMore }) => ({ showMore: !showMore }));
  }

  toggleSTU(force = null) {
    const { STUEditMode } = this.state;
    if (force === null) {
      this.setState({
        STUEditMode: !STUEditMode,
      });
    } else {
      this.setState({
        STUEditMode: force,
      });
    }
  }

  isImage(url) {
    return new Promise(resolve => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    }).then(resp=>{this.setState({hasImage:resp})})
  }

  render() {
    const { showMore, STUEditMode,hasImage } = this.state;
    const {
      intl,
      data,
      currentLanguage,
      editableFormula,
      editFormula,
      cancelEditFormula,
      goToListing,
      code,
    } = this.props;
    const { globalShippingProgram } = data;
    let gspMessage = ' ';
    if (typeof globalShippingProgram === 'boolean') {
      gspMessage = <FormattedMessage id={globalShippingProgram ? 'common.yes' : 'common.no'} />;
    }
    let stu = '';
    if (data.sourceTrackingUrl) {
      if (STUEditMode) {
        stu = data.sourceTrackingUrl;
      } else {
        stu = (
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={data.sourceTrackingUrl}
            css={css`
              text-decoration: underline;
            `}
          >
            {data.sourceTrackingUrl.slice(0, 25)}...
          </a>
        );
      }
    }

    const deliveryImage=`https://tracking-html.s3.us-east-2.amazonaws.com/tracking-images/${data.sourceOrderNumber}`;

    return (
      <Fragment>
        <InfoValue>
          <a
            onClick={goToListing}
            css={css`
              text-decoration: underline;
            `}
          >
            <FormattedMessage id="orders.triplemarsUrl" />
          </a>
        </InfoValue>
        <InfoRow
          value={
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={formatOfferUrl(data.sourceItemCode, data.sourceMarketplaceId)}
              css={css`
                text-decoration: underline;
              `}
            >
              {data.sourceItemCode}
            </a>
          }
          titleId="orders.sourceUrl"
        />
        <InfoRow
          value={
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={data.destinationItemUrl}
              css={css`
                text-decoration: underline;
              `}
            >
              {data.destinationItemId}
            </a>
          }
          titleId="orders.destinationUrl"
        />
        <InfoRow value={getFormattedDate(data.orderPlacedTime)} titleId="orders.orderPlaced" />
        <InfoRow value={getFormattedDate(data.purchaseTime)} titleId="orders.purchaseTime" />
        <InfoRow value={getFormattedDate(data.listDate)} titleId="orders.listDate" />
        <InfoRow
          value={getFormattedDate(data.estimatedArrivalDate)}
          titleId="orders.estArrivalDate"
        />
        <InfoRow value={data.buyerUsername} titleId="orders.buyerUsername" />
        <InfoRow
          value={
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={formatOrderUrl(
                data.destinationOrderId.split('-')[1],
                data.destinationItemId,
                data.destinationMarketplaceId,
              )}
              css={css`
                text-decoration: underline;
              `}
            >
              {data.destinationOrderId.split('-')[1]}
            </a>
          }
          titleId="orders.destinationOrderId"
        />
        <InfoRow value={data.destinationAccount} titleId="orders.destinationAccount" />
        <InfoRow
          value={
            <Link
              css={css`
                text-decoration: underline;
              `}
              to={{
                pathname: `/orders/trackingInfo/${code}`,
              }}
            >
              More Details
            </Link>
          }
          title="Tracking Details"
        />
        <InfoRow value={data.quantity} titleId="common.qty" />
        <InfoRow value={data.orderedBy} titleId="orders.orderedBy" />
        <InfoRow
          value={data.salePrice}
          titleId="orders.orderPricing"
          css={css`
            margin-bottom: 20px;
          `}
        />
        <SubTitle>
          Orders Pricing
          {!editableFormula ? (
            <IconSvg type="pencil" size={20} marginLeft="20px" onClick={editFormula} />
          ) : (
            <IconSvg
              type="v"
              size={20}
              marginLeft="20px"
              onClick={() => {
                cancelEditFormula();
                data.parseAllPricing();
              }}
            />
          )}
        </SubTitle>
        <ProfitFormula
          editable={editableFormula}
          data={data}
          currentLanguage={currentLanguage}
          intl={intl}
        />
        {showMore && (
          <Fragment>
            <SubTitle>{intl.formatMessage({ id: 'orders.buyerInfo' })}</SubTitle>
            <InfoRow
              value={data.buyerName}
              titleId="common.name"
              type="text"
              editable
              onChange={data.setBuyerName}
            />
            <InfoRow
              value={data.buyerEmail}
              titleId="common.email"
              type="text"
              editable
              onChange={data.setBuyerEmail}
            />
            <InfoRow
              value={data.shippingMethod}
              titleId="orders.shippingMethod"
              editable
              onChange={data.setShippingMethod}
            />
            <SubTitle>{intl.formatMessage({ id: 'common.address' })}</SubTitle>
            <InfoRow
              value={data.shippingBuyerName}
              titleId="common.name"
              type="text"
              editable
              onChange={data.setShippingBuyerName}
            />
            <InfoRow
              value={data.buyerAddressLine1}
              titleId="orders.addressLine1"
              onChange={data.setAddressLine1}
              editable
              type="text"
            />
            <InfoRow
              value={data.buyerAddressLine2}
              titleId="orders.addressLine2"
              onChange={data.setAddressLine2}
              editable
              type="text"
            />
            <InfoRow
              value={data.buyerAddressCity}
              titleId="orders.city"
              onChange={data.setCity}
              editable
              type="text"
            />
            <InfoRow
              value={data.buyerAddressState}
              titleId="orders.state"
              onChange={data.setState}
              editable
              type="text"
            />
            <InfoRow
              value={data.buyerAddressZipCode}
              titleId="orders.zipCode"
              onChange={data.setZipCode}
              editable
              type="text"
            />
            <InfoRow
              value={data.buyerAddressCountry}
              titleId="common.country"
              onChange={data.setCountry}
              editable
              type="text"
            />
            <InfoRow
              value={data.buyerPhoneNumber}
              titleId="orders.phoneNumber"
              onChange={data.setPhoneNumber}
              editable
              type="text"
              css={css`
                margin-bottom: 20px;
              `}
            />

            <SubTitle>{intl.formatMessage({ id: 'orders.purchaseInfo' })}</SubTitle>
            <div
              css={css`
                position: relative;
              `}
            >
              <InfoRow
                value={stu}
                titleId="orders.trackingURL"
                onChange={data.setSourceTrackingUrl}
                editable={STUEditMode}
                type="text"
                error={
                  data.invalidSourceTrackingUrl
                    ? intl.formatMessage({ id: 'orders.invalidSTU' })
                    : null
                }
              />
              <div
                css={css`
                  position: absolute;
                  top: 0;
                  right: 0;
                  margin-right: -30px;
                `}
              >
                {!STUEditMode && data.status === 'ordered' && (
                  <IconSvg
                    type="pencil"
                    size={20}
                    marginLeft="20px"
                    onClick={() => this.toggleSTU(true)}
                  />
                )}
                {STUEditMode && data.status === 'ordered' && (
                  <IconSvg
                    type="v"
                    size={20}
                    marginLeft="20px"
                    onClick={() => this.toggleSTU(false)}
                  />
                )}
              </div>
            </div>
            <InfoRow
              value={data.trackingNumber}
              titleId="orders.trackingNumber"
              onChange={data.setTrackingNumber}
              editable
              type="text"
            />
            <InfoRow
              value={data.carrier}
              titleId="orders.carrier"
              onChange={data.setCarrier}
              editable
              type="text"
            />
            {data.originalTrackingNumber && (
              <>
                <InfoRow
                  value={data.originalCarrier}
                  title="Original Carrier"
                  onChange={data.setOriginalCarrier}
                  editable={false}
                  type="text"
                />

                <InfoRow
                  value={data.originalTrackingNumber}
                  title="Original Tracking Number"
                  onChange={data.setOriginalTrackingNumber}
                  editable={false}
                  type="text"
                />
              </>
            )}
            {data.isGlobalOrder ? (
              <InfoRow
                css={css`
                  margin-bottom: 15px;
                `}
                value={data.internationalTrackingNumber}
                titleId="orders.internationalTrackingNumber"
                editable={false}
                type="text"
              />
            ) : null}
            {data.isGlobalOrder ? (
              <InfoRow
                value={data.internationalCarrier}
                titleId="orders.internationalCarrier"
                editable={false}
                type="text"
              />
            ) : null}
            {data.isBuyItForMe ? (
              <InfoRow
                value={<FormattedMessage id="orders.TMAccountUsed" />}
                titleId="orders.sourceAccount"
                type="text"
              />
            ) : (
              <InfoRow
                value={data.sourceAccount}
                titleId="orders.sourceAccount"
                onChange={data.setSourceAccount}
                editable
                type="text"
              />
            )}
            <InfoRow
              value={data.sourceOrderNumber}
              titleId="orders.sourceOrderNum"
              onChange={data.setSourceOrderNum}
              editable
              type="text"
            />
            {
              hasImage && (
                <InfoRow
                  titleId="orders.deliveryImage"
                  css={css`
                margin-bottom: 40px;
                `}
                >
                  <Popover
                    content={<img src={deliveryImage} alt="description" width={460} height={480} />}
                    title=""
                    trigger="hover"
                    placement="top"
                  >
                    <a href={deliveryImage} target='_blank'><img src={deliveryImage} width={50} height={50} style={{ cursor: 'pointer' }} /></a>
                  </Popover>
                </InfoRow>
              )
            }
            {
              hasImage && (
                <InfoRow
                  value={data.deliveryMessage}
                  titleId="orders.deliveryMessage"
                  editable={false}
                  type="text"
                  css={css`
                  margin-bottom: 20px;
                  `}
                  valueStyle={{marginLeft:'55px'}}
                />
              )
            }
            <InfoRow
              value={gspMessage}
              titleId="listing.ebayGlobalShippingProgram"
              type="text"
              css={css`
                margin-bottom: 20px;
              `}
            />
          </Fragment>
        )}
        <CollapseButton
          css={css`
            ${text2};
            ${showMore ? arrowUp : arrowDown}
            width: auto;
          `}
          onClick={this.toggleShowMore}
        >
          {intl.formatMessage({ id: showMore ? 'orders.showLess' : 'orders.showMore' })}
        </CollapseButton>
      </Fragment>
    );
  }
}

ItemInfo.propTypes = {
  data: PropTypes.object,
  intl: PropTypes.object,
  currentLanguage: PropTypes.string,
  cancelEditFormula: PropTypes.func,
  editFormula: PropTypes.func,
};
